<template>
<v-container style="width: 100%; height: 100vh;">
    <v-overlay color="iq_dark" :value="globalLoader">
        <v-progress-circular
            indeterminate
            size="70"
            width="7"
            color="primary"
        ></v-progress-circular>
    </v-overlay>
    <v-card-text style="width: 100%; height: 100vh;" v-if="iframeUrl !== null">
        <iframe
            v-if="iframeUrl"
            :src="iframeUrl"
            width="100%"
            height="100%"
            frameborder="0"
            allowfullscreen
        ></iframe>
    </v-card-text>
</v-container>
</template>
<script>

import moment from "moment";
import Templates from '../components/AdminComponents/Templates.vue';
import { mapGetters } from 'vuex';
import Popover from '../components/shared/_popover.vue';
// import gsap from 'gsap';
export default {
    components: { Templates,Popover },
    data () {
        return {
            globalLoader : true,
            iframeUrl: null
        }
    }, 
    computed: {
        ...mapGetters({
            currentCompany: 'company/getCurrentCompany'
        })
    }, 
    created(){
        this.globalLoader = true;

        this.$auth.auth0ClientPromise.then(async () => {
            if(Object.keys(this.currentCompany).length === 0){
                await this.$store.dispatch('getUserCompany');
                
                let iframeData = await this.$store.dispatch('company/getReportIFrane');
                this.iframeUrl = iframeData.iFrameUrl;

                this.globalLoader = false;
            }else{
                
                let iframeData = await this.$store.dispatch('company/getReportIFrane');
                this.iframeUrl = iframeData.iFrameUrl;

                this.globalLoader = false;
            }
        });        
    },
    destroyed() { //LAYOUT TOOL: on leave dispose
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>